import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchBulkMembers } from './bulk-tools.action';
import { Observable } from 'rxjs';
import { selectBulkMembers } from './bulk-tools-selector';

@Injectable({ providedIn: 'root' })
export class BulkToolTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) {
        //Used Only If Multiselect Chcekbox Exist
        this.recordsList$ = this.store.select(selectBulkMembers);
        this.store.select(selectBulkMembers)
                    .subscribe((bulkMembers) => {
                        // console.log("In bulktable service.ts");
                        this.allCurrentValues = [];
                        if(bulkMembers?.length > 0){
                            bulkMembers.forEach((row: any) => {
                                this.allCurrentValues.push(row.id);
                            });
                        }
                    });
    }
 
    pagination = [];
    filters = {
                id: '',
                created_at: '',
                debtor_name: '',
                club_name: null,
                outstanding_with_fee: '',
                dossier_categories_name: '',
                team: '',
                is_paid: null
            };


    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    actionId = "0";
    allSelectionValues: Set<number> = new Set();
    allCurrentValues = [];
    allCheckboxValue: boolean = false;

    statuses = [
        {id: "0", value: "DOSSIER.pending"},
        {id: "1", value: "DOSSIER.paid"}
    ];
    clubs = [];
    outstandings = [
        {"id": "1", "name": "COMMON.yes"},
        {"id": "0", "name": "COMMON.no"}
    ];
    columns = [
                { prop: 'checkbox', name: '', sortable: false, hasFilter: false, checkAllBox: true, filter: "input", widthSet: 40},
                { prop: 'id', name: 'BULK_TOOLS.dossier-id', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date"},
                { prop: 'debtor_name', name: 'BULK_TOOLS.debtor-name', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'club_name', name: 'BULK_TOOLS.club', sortable: true, hasFilter: true, filter: "select", options: 'clubs', options_id: "id", options_label: "club_name"},
                { prop: 'dossier_categories_name', name: 'DOSSIER.category', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'team', name: 'DOSSIER.team', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'outstanding_with_fee', name: 'BULK_TOOLS.outstanding', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'is_paid', name: 'BULK_TOOLS.status', sortable: true, hasFilter: true, filter: "select", options: 'statuses', options_id: "id", options_label: "value"}
            ];

    recordsList$: Observable<any>; //Used Only If Multiselect Chcekbox Exist

    loadRecords() {
        this.allCheckboxValue = false;
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchBulkMembers());
    }

    hasActiveFilters(){

        if(
            // (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            Object.entries(this.filters).some(([key, value]) => {
                if (key === 'member_status'){
                    return value !== '1';
                }

                return value !== '' && value !== null;
            }) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        

    }

    resetState(){
        this.allCheckboxValue = false;
        this.filters = {
             id: '',
            created_at: '',
            debtor_name: '',
            club_name: null,
            outstanding_with_fee: '',
            dossier_categories_name: '',
            team: '',
            is_paid: null
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;
    }

    resetFilters(){
        this.resetState();
        this.loadRecords();
    }

    allSelection(event){
        
        let checked = (event.target as HTMLInputElement).checked;
        if(checked){
            this.allCheckboxValue = true;
            this.allCurrentValues.forEach(id => {
                if (!this.allSelectionValues.has(id))
                    this.allSelectionValues.add(id);
            });
        }else{
            this.allCheckboxValue = false;
            this.allCurrentValues.forEach(id => {
                this.allSelectionValues.delete(id)
            });
        }

    }

}